import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { businessModel } from '@/mocks/invest';

export default function BusinessModel() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="商业模式"
            title="价值流转与收入闭环"
            subtitle="数字货架连接交易，数字消费驱动增长，智能清分实现多方共利，华辉数智通过技术服务获取收入。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {businessModel.map((b, i) => (
            <Reveal key={b.title} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors flex flex-col">
                <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className={`${b.icon} text-accent-600 text-2xl`}></i>
                </div>
                <div className="mt-4 text-xs font-medium text-foreground-500">{b.role}</div>
                <h3 className="mt-1 font-heading font-bold text-lg text-foreground-950">{b.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{b.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}